import { render, staticRenderFns, recyclableRender, components } from "./wxParseTemplate6.vue?vue&type=template&id=30833784&"
var renderjs
import script from "./wxParseTemplate6.vue?vue&type=script&lang=js&"
export * from "./wxParseTemplate6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/u-parse/components/wxParseTemplate6.vue"
export default component.exports